import styled, { keyframes } from 'styled-components';
import { theme } from '../../styles/theme';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: ${theme.fonts.main};
`;

export const MainLeaderSection = styled.section`
  margin-bottom: 4rem;
  display: flex;
  justify-content: center;
`;

export const MainLeaderCard = styled.div`
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(26, 35, 126, 0.15);
  padding: 3rem;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 3rem;
  align-items: start;
  max-width: 1000px;
  width: 100%;
  animation: ${fadeInUp} 0.8s ease-out 0.2s both;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 2rem;
    text-align: center;
  }
`;

export const MainLeaderAvatar = styled.div`
  width: 160px;
  height: 200px;
  border-radius: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: white;
  font-weight: bold;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  @media (max-width: 768px) {
    width: 120px;
    height: 150px;
    margin: 0 auto 1.5rem auto;
    font-size: 2.5rem;
  }
`;

export const MainLeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MainLeaderName = styled.h2`
  font-weight: 700;
  font-size: 2rem;
  margin: 0 0 0.5rem 0;
  color: ${theme.colors.text};
  
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const MainLeaderTitle = styled.h3`
  font-size: 1.3rem;
  margin: 0 0 1.5rem 0;
  font-weight: 600;
  color: ${theme.colors.primary};
`;

export const MainAchievementsList = styled.ul`
  padding-left: 1.5rem;
  margin: 0;
  font-size: 1rem;
  line-height: 1.8;
  color: ${theme.colors.text};
  
  li {
    margin-bottom: 0.2rem;
  }
  
  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const SubLeadersSection = styled.section`
  margin-bottom: 5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const SubLeaderCard = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(26, 35, 126, 0.1);
  padding: 2rem;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1.5rem;
  align-items: start;
  animation: ${fadeInUp} 0.8s ease-out 0.4s both;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const SubLeaderAvatar = styled.div`
  width: 130px;
  height: 165px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
  font-weight: bold;
  overflow: hidden;
  flex-shrink: 0;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  @media (max-width: 768px) {
    margin: 0 auto 1rem auto;
  }
`;

export const SubLeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubLeaderName = styled.h3`
  font-weight: 700;
  font-size: 1.4rem;
  margin: 0 0 0.2rem 0;
  color: ${theme.colors.text};
`;

export const SubLeaderTitle = styled.h4`
  font-size: 1rem;
  margin: 0 0 1rem 0;
  font-weight: 600;
  color: ${theme.colors.primary};
`;

export const SubAchievementsList = styled.ul`
  padding-left: 1.2rem;
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.6;
  color: ${theme.colors.text};
  
  li {
    margin-bottom: 0.5rem;
  }
  
  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const CarouselSection = styled.section`
  margin-top: 4rem;
  text-align: center;
`;

export const CarouselTitle = styled.h2`
  font-size: 2rem;
  color: ${theme.colors.primary};
  margin-bottom: 2rem;
  font-weight: 600;
`;

export const CarouselContainer = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 2rem 0;
  position: relative;
`;

export const CarouselSlide = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
`;

export const TeacherPhoto = styled.div`
  width: 120px;
  height: 140px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  flex-shrink: 0;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    transition: transform 0.3s ease;
  }
  
  @media (max-width: 1200px) {
    width: 100px;
    height: 120px;
  }
  
  @media (max-width: 768px) {
    width: 80px;
    height: 100px;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    width: 70px;
    height: 85px;
  }
`;

export const TeamStats = styled.div`
  margin-top: 2rem;
  text-align: center;
  color: ${theme.colors.text};
  font-size: 1.1rem;
  font-weight: 500;
  
  span {
    color: ${theme.colors.primary};
    font-weight: 700;
    font-size: 1.3rem;
  }
`;